module.exports = __webpack_public_path__ + "fonts/icons.8e3c7f55.8e3c7f55.eot";